import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'login-ui-container',
  standalone: true,
  imports: [
    CommonModule
  ],
  templateUrl: './login-ui-container.component.html',
  styleUrl: './login-ui-container.component.scss'
})
export class LoginUiContainerComponent {
  @Input() showLoginBanner!: Function;
}
